import { required } from '@vuelidate/validators'

export const CreateTemplateSparkValidation = {
    cityId: { required },
    fullAddress: { required },
    phone: { required },
    fullName: { required },
    latitude: { required },
    longitude: { required },
}
